import { render, staticRenderFns } from "./scrolllist.vue?vue&type=template&id=ea81c896&scoped=true&"
import script from "./scrolllist.vue?vue&type=script&lang=js&"
export * from "./scrolllist.vue?vue&type=script&lang=js&"
import style0 from "./scrolllist.vue?vue&type=style&index=0&id=ea81c896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea81c896",
  null
  
)

export default component.exports